// The outcomes a person can record when closing an intervention that reached service delivery, which are also the
// three "case status" options on the Case Closure Form. First call resolution and referral provided come from the
// path taken, never from a choice. The server enforces this; the list only decides what the screens offer.
export const SERVICE_CLOSURE_OUTCOME_CODES: readonly string[] = [
  'COUNSELLING_COMPLETED',
  'NO_INITIAL_CONTACT',
  'CLIENT_DROPPED_OUT',
];
